<template>
    <form autocomplete="off">
        <p><span class="color--red">Attention!</span></p>
        <p v-if="method === 'banktransfer'" >Due to legal regulations you can’t withdraw more than FND 15,000 every 10 days.</p>
        <p>Maximum amount of a single withdrawal is FND 10,000.</p>
        <div style="margin-bottom: 24px;"></div>
        <b-row class="payout-option-inner">
            <amount :sending="sending"
                    :show-errors="showErrors"
                    :percent="amountParams[method].percent"
                    :minimum="amountParams[method].minimum"
                    :amount-error="amountError"
                    :max-amount-error="maxAmountError"
                    :set-value="setValue"></amount>
        </b-row>
        <p class="field-error--description"
           v-show="parseFloat(account.amount) < amountParams[method].minimum && showErrors">Minimum payout amount is FND {{ amountParams[method].minimum }}</p>
        <p class="field-error--description"
           v-show="available < account.amount && showErrors && !amountParams[method].percent">
            You do not have enough money to withdraw that amount and pay fee. If you want to use this payout gateway you can withdraw FND {{ available }}
        </p>
        <p class="field-error--description"
           v-show="maxAmountError">You cannot withdraw more than FND 10,000 once.</p>
        <p class="field-error--description"
           v-show="available < account.amount && showErrors && amountParams[method].percent">
            You do not have enough money to withdraw that amount and pay fee.
        </p>
        <p>+ fee: FND {{ feeValue.toFixed(2) }}</p>
        <div style="margin: 24px;"></div>
        <bank-transfer v-if="method === 'banktransfer'"
                       :sending="sending"
                       :show-errors="showErrors"
                       :set-value="setValue"></bank-transfer>
        <bitcoin v-if="method === 'bitcoin'"
                 :countries="countries"
                 :sending="sending"
                 :show-errors="showErrors"
                 :set-value="setValue"></bitcoin>
        <neteller v-if="method === 'neteller'"
                  :countries="countries"
                  :sending="sending"
                  :show-errors="showErrors"
                  :set-value="setValue"></neteller>
        <payza v-if="method === 'payza'"
               :countries="countries"
               :sending="sending"
               :show-errors="showErrors"
               :set-value="setValue"></payza>
        <perfect-money v-if="method === 'perfectmoney'"
                       :countries="countries"
                       :sending="sending"
                       :show-errors="showErrors"
                       :set-value="setValue"></perfect-money>
        <stp v-if="method === 'stp'"
             :countries="countries"
             :sending="sending"
             :show-errors="showErrors"
             :set-value="setValue"></stp>
        <advcash v-if="method === 'advcash'"
             :countries="countries"
             :sending="sending"
             :show-errors="showErrors"
             :set-value="setValue"></advcash>
        <!--<coindeal v-if="method === 'coindeal_futurocoin'"-->
                 <!--:countries="countries"-->
                 <!--:method="method"-->
                 <!--:method-name="'FuturoCoin'"-->
                 <!--:sending="sending"-->
                 <!--:show-errors="showErrors"-->
                 <!--:set-value="setValue"></coindeal>-->
        <!--<coindeal v-if="method === 'coindeal_bitcoin'"-->
                  <!--:countries="countries"-->
                  <!--:method="method"-->
                  <!--:method-name="'Bitcoin'"-->
                  <!--:sending="sending"-->
                  <!--:show-errors="showErrors"-->
                  <!--:set-value="setValue"></coindeal>-->
        <!--<coindeal v-if="method === 'coindeal_litecoin'"-->
                 <!--:countries="countries"-->
                 <!--:method="method"-->
                 <!--:method-name="'Litecoin'"-->
                 <!--:sending="sending"-->
                 <!--:show-errors="showErrors"-->
                 <!--:set-value="setValue"></coindeal>-->
        <!--<coindeal v-if="method === 'coindeal_bitcoin_cash'"-->
                  <!--:countries="countries"-->
                  <!--:method="method"-->
                  <!--:method-name="'Bitcoin Cash'"-->
                  <!--:sending="sending"-->
                  <!--:show-errors="showErrors"-->
                  <!--:set-value="setValue"></coindeal>-->
        <!--<coindeal v-if="method === 'coindeal_dash'"-->
                  <!--:countries="countries"-->
                  <!--:method="method"-->
                  <!--:method-name="'Dash'"-->
                  <!--:sending="sending"-->
                  <!--:show-errors="showErrors"-->
                  <!--:set-value="setValue"></coindeal>-->
        <!--<coindeal v-if="method === 'coindeal_ethereum'"-->
                  <!--:countries="countries"-->
                  <!--:method="method"-->
                  <!--:method-name="'Ethereum'"-->
                  <!--:sending="sending"-->
                  <!--:show-errors="showErrors"-->
                  <!--:set-value="setValue"></coindeal>-->
        <b-row class="payout-option-inner payout-option-inner--actions">
            <b-col lg="6">
                <button class="button--primary"
                        type="button"
                        @click="validate()">Payout</button>
            </b-col>
        </b-row>
    </form>
</template>

<script>
    import Amount from './common/Amount.vue';
    import BankTransfer from './BankTransfer.vue';
    import Bitcoin from './Bitcoin.vue';
    import Coindeal from './Coindeal.vue';
    import Neteller from './Neteller.vue';
    import Payza from './Payza.vue';
    import PerfectMoney from './PerfectMoney.vue';
    import Stp from './Stp.vue';
    import Advcash from './Advcash';
    import TwoPayFourYou from './TwoPayFourYou.vue';
    export default {
        components: { Amount, BankTransfer, Bitcoin, Coindeal, Neteller, Payza, PerfectMoney, Stp, Advcash, TwoPayFourYou },
        dependencies: ['money', 'payout'],
        props: ['method'],
        data () {
            return {
                methodFields      : {
                    banktransfer            : ['identifier', 'owner', 'bic', 'street', 'zip', 'city', 'currency'],
                    bitcoin                 : ['identifier', 'country'],
                    neteller                : ['identifier', 'country'],
                    payza                   : ['identifier', 'country'],
                    perfectmoney            : ['identifier', 'country'],
                    stp                     : ['identifier', 'country'],
                    advcash                 : ['identifier', 'country'],
                    coindeal_futurocoin     : ['identifier', 'country'],
                    coindeal_bitcoin        : ['identifier', 'country'],
                    coindeal_litecoin       : ['identifier', 'country'],
                    coindeal_bitcoin_cash   : ['identifier', 'country'],
                    coindeal_dash           : ['identifier', 'country'],
                    coindeal_ethereum       : ['identifier', 'country']
                },
                pendingPayouts  : true,
                sending         : false,
                amountError     : false,
                maxAmountError  : false,
                showErrors      : false,
                account         : {
                    amount          : '',
                    identifier      : '',
                    owner           : '',
                    bic             : '',
                    street          : '',
                    zip             : '',
                    city            : '',
                    country         : '',
                    currency        : '',
                    description     : '',
                    password        : ''
                },
                amountParams : {
                    banktransfer    : {
                        fee     : 7,
                        percent : false,
                        minimum : 50
                    },
                    bitcoin    : {
                        fee     : 7,
                        percent : false,
                        minimum : 50
                    },
                    neteller    : {
                        fee     : 2.5,
                        percent : true,
                        minimum : 50
                    },
                    payza    : {
                        fee     : 3.9,
                        percent : true,
                        minimum : 50
                    },
                    perfectmoney    : {
                        fee     : 2.5,
                        percent : true,
                        minimum : 50
                    },
                    stp    : {
                        fee     : 2.5,
                        percent : false,
                        minimum : 50
                    },
                    advcash : {
                        fee     : 2.5,
                        percent : false,
                        minimum : 50
                    },
                    coindeal_futurocoin: {
                        fee     : 1,
                        percent : false,
                        minimum : 5
                    },
                    coindeal_bitcoin: {
                        fee     : 2,
                        percent : false,
                        minimum : 5
                    },
                    coindeal_litecoin: {
                        fee     : 2,
                        percent : false,
                        minimum : 5
                    },
                    coindeal_bitcoin_cash: {
                        fee     : 2,
                        percent : false,
                        minimum : 5
                    },
                    coindeal_dash:  {
                        fee     : 2,
                        percent : false,
                        minimum : 5
                    },
                    coindeal_ethereum:  {
                        fee     : 2,
                        percent : false,
                        minimum : 5
                    }
                },
                maxAmount: 10000
            }
        },
        computed: {
            available () {
                return this.money.format(this.$store.getters.user.moneyBalance, 'fnd') - parseFloat(this.feeValue.toFixed(2));
            },
            countries () {
                return this.$store.getters.countries;
            },
            feeValue () {
                if (this.amountParams[this.method].percent) {
                    return (this.account.amount * this.amountParams[this.method].fee) / 100;
                }
                return this.amountParams[this.method].fee;
            }
        },
        methods: {
            setValue (key, value) {
                this.account[key] = value;
                if (key === 'amount') {
                    this.amountError = !(parseFloat(this.account.amount) >= this.amountParams[this.method].minimum) && (parseFloat(this.account.amount) <= this.available);
                }
            },
            validate () {
                this.showErrors = false;
                this.amountError = false;
                this.maxAmountError = false;
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any() &&
                        (parseFloat(this.account.amount) >= this.amountParams[this.method].minimum) &&
                        (parseFloat(this.account.amount) <= this.available) &&
                         parseFloat(this.account.amount) <= this.maxAmount) {
                        this.submit();
                    } else {
                        this.showErrors = true;

                        if (this.account.amount < this.amountParams[this.method].minimum || this.account.amount > this.available) {
                            this.amountError = true;
                        }

                        if (parseFloat(this.account.amount) > this.maxAmount) {
                            this.maxAmountError = true;
                        }
                    }
                });
            },
            submit () {
                let method = this.method,
                    account = {};

                for (let field in this.methodFields[method]) {
                    switch (this.methodFields[method][field]) {
                        case 'street':
                        case 'country':
                            if (account.address) {
                                account.address.line1 += ' ' + this.account[this.methodFields[method][field]];
                            } else {
                                account.address = {
                                    line1: this.account[this.methodFields[method][field]]
                                };
                            }
                            break;
                        case 'zip':
                        case 'city':
                            if (account.address.line2) {
                                account.address.line2 += ' ' + this.account[this.methodFields[method][field]];
                            } else {
                                account.address.line2 = this.account[this.methodFields[method][field]];
                            }
                            break;
                        default:
                            account[this.methodFields[method][field]] = this.account[this.methodFields[method][field]];
                    }
                }

                let params = {
                    method      : this.method,
                    amount      : this.money.unformat(this.account.amount, 'fnd'),
                    password    : this.account.password,
                    account     : account
                };

                if (params.method === 'advcash') {
                    account.country = account.address.line1;
                }

                this.payout.generateToken().then(() => {
                    this.$store.commit('modals', {
                        modal: 'payout',
                        data: {
                            visible: true,
                            params: params
                        }
                    });
                });
            }
        },
        watch : {
            method () {
                this.errors.clear();
                this.$forceUpdate();
            }
        },
        mounted () {
            this.$store.commit('modals', {
                modal: 'payout',
                data: {
                    visible: false,
                    params: {}
                }
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/payout/PayoutForm.vue